/*
 * Stellenübersicht und Bewerbungsformular.
 *
 * Spricht ausschließlich den Shopify App Proxy unter /apps/jobs/api/* an;
 * Shopify signiert die Aufrufe und leitet sie an Bifrost weiter. Alle Texte
 * kommen aus den Section-Settings (data-strings), damit sie im Theme-Editor
 * pflegbar bleiben.
 */
(function () {
  'use strict'

  var API = '/apps/jobs/api'

  function strings(root) {
    try {
      return JSON.parse(root.dataset.strings || '{}')
    } catch (e) {
      return {}
    }
  }

  function show(el) {
    if (el) el.hidden = false
  }
  function hide(el) {
    if (el) el.hidden = true
  }
  function target(root, name) {
    return root.querySelector('[data-target="' + name + '"]')
  }
  function slot(scope, name) {
    return scope.querySelector('[data-slot="' + name + '"]')
  }

  function fail(root, message) {
    hide(target(root, 'loading'))
    var box = target(root, 'error')
    if (box) {
      box.textContent = message
      show(box)
    }
  }

  async function getJSON(url) {
    var res = await fetch(url, { headers: { Accept: 'application/json' } })
    var body = await res.json().catch(function () {
      return null
    })
    if (!body) throw new Error('Ungültige Antwort')
    return { ok: res.ok, status: res.status, body: body }
  }

  async function postJSON(url, payload) {
    var res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
    var body = await res.json().catch(function () {
      return null
    })
    return { ok: res.ok, status: res.status, body: body || {} }
  }

  /* ── Übersicht ──────────────────────────────────────────────────── */

  var GROUPS = [
    { key: 'FULLTIME', title: 'group_fulltime', empty: 'empty_fulltime' },
    { key: 'PARTTIME', title: 'group_parttime', empty: 'empty_parttime' },
    { key: 'INTERNSHIP', title: 'group_internship', empty: 'empty_internship' },
  ]

  async function initOverview(root) {
    var t = strings(root)
    var detailUrl = root.dataset.detailUrl || '/pages/job'

    var result
    try {
      result = await getJSON(API + '/positions')
    } catch (e) {
      return fail(root, t.error_text)
    }
    if (!result.ok || !result.body.ok) return fail(root, t.error_text)

    var container = target(root, 'groups')
    var groupTpl = root.querySelector('[data-template="group"]')
    var jobTpl = root.querySelector('[data-template="job"]')

    GROUPS.forEach(function (group) {
      var jobs = result.body.groups[group.key] || []
      var node = groupTpl.content.cloneNode(true)
      slot(node, 'title').textContent = t[group.title] || group.key

      var list = slot(node, 'list')
      if (jobs.length === 0) {
        var empty = slot(node, 'empty')
        empty.textContent = t[group.empty] || ''
        empty.hidden = false
      }

      jobs.forEach(function (job) {
        var item = jobTpl.content.cloneNode(true)
        slot(item, 'title').textContent = job.title

        if (job.requiredLanguage) {
          var langName = t['lang_' + job.requiredLanguage] || job.requiredLanguage
          var badge = slot(item, 'lang')
          badge.textContent = (t.lang_required || 'nativ {lang}').replace('{lang}', langName)
          badge.hidden = false
        }

        var link = slot(item, 'link')
        link.href = detailUrl + '?stelle=' + encodeURIComponent(job.slug)
        slot(item, 'button-label').textContent = t.button_details || 'Details'
        // Der sichtbare Button ist aria-hidden — sein Text wäre für
        // Screenreader ein zweites, nichtssagendes "Details" neben dem
        // eigentlichen Link. Deshalb trägt der Link selbst das Ziel.
        link.setAttribute(
          'aria-label',
          job.title + ' – ' + (t.button_details || 'Details'),
        )
        list.appendChild(item)
      })

      container.appendChild(node)
    })

    hide(target(root, 'loading'))
    show(container)
  }

  /* ── Detail + Bewerbung ─────────────────────────────────────────── */

  var UPLOADS = [
    { kind: 'COVER_LETTER', flag: 'requiresCoverLetter', label: 'label_cover_letter' },
    { kind: 'CV', flag: 'requiresCv', label: 'label_cv' },
    { kind: 'PHOTO', flag: 'requiresPhoto', label: 'label_photo' },
  ]

  var TYPE_LABEL = {
    FULLTIME: 'type_fulltime',
    PARTTIME: 'type_parttime',
    INTERNSHIP: 'type_internship',
  }

  function addMeta(dl, label, value) {
    if (!value) return
    var dt = document.createElement('dt')
    dt.textContent = label
    var dd = document.createElement('dd')
    dd.textContent = value
    dl.appendChild(dt)
    dl.appendChild(dd)
  }

  /* JobPosting-Auszeichnung für Google Jobs — nur wenn die Pflichtangaben
     da sind, sonst meldet die Search Console unvollständige Daten. */
  function addJsonLd(job) {
    if (!job.propIndustry || !job.propEmploymentType || !job.propWorkHours) return
    var data = {
      '@context': 'https://schema.org',
      '@type': 'JobPosting',
      title: job.title,
      description: job.description,
      industry: job.propIndustry,
      employmentType: job.propEmploymentType,
      workHours: job.propWorkHours,
      hiringOrganization: {
        '@type': 'Organization',
        name: 'getDigital',
        sameAs: 'https://www.getdigital.de',
      },
      jobLocation: {
        '@type': 'Place',
        address: {
          '@type': 'PostalAddress',
          addressLocality: (job.propLocation || '').split(',')[0].trim(),
          addressRegion: ((job.propLocation || '').split(',')[1] || '').trim(),
          addressCountry: 'DE',
        },
      },
    }
    if (job.propBaseSalary && job.propSalaryCurrency) {
      data.baseSalary = {
        '@type': 'MonetaryAmount',
        currency: job.propSalaryCurrency,
        value: { '@type': 'QuantitativeValue', value: job.propBaseSalary },
      }
    }
    var tag = document.createElement('script')
    tag.type = 'application/ld+json'
    tag.textContent = JSON.stringify(data)
    document.head.appendChild(tag)
  }

  async function initDetail(root) {
    var t = strings(root)
    var slug = new URLSearchParams(window.location.search).get('stelle')
    if (!slug) return fail(root, t.not_found_text)

    var result
    try {
      result = await getJSON(API + '/positions/' + encodeURIComponent(slug))
    } catch (e) {
      return fail(root, t.error_text)
    }
    if (result.status === 404) return fail(root, t.not_found_text)
    if (!result.ok || !result.body.ok) return fail(root, t.error_text)

    var job = result.body.job
    var article = target(root, 'article')

    document.title = job.seoTitle || job.title
    slot(article, 'title').textContent = job.title

    var meta = slot(article, 'meta')
    addMeta(meta, t.meta_location, job.propLocation)
    addMeta(meta, t.meta_industry, job.propIndustry)
    addMeta(
      meta,
      t.meta_hours,
      [t[TYPE_LABEL[job.type]], job.propWorkHours].filter(Boolean).join(', '),
    )
    addMeta(meta, t.meta_salary, job.propBaseSalary)

    // Beschreibungsfelder sind bewusst HTML: sie werden im Admin von
    // Mitarbeitern gepflegt, genau wie in der alten Verwaltung.
    slot(article, 'description').innerHTML = job.description || ''
    if (job.requirements) {
      slot(article, 'requirements').innerHTML = job.requirements
      show(slot(article, 'requirements-wrap'))
    }
    if (job.whyUs) {
      slot(article, 'whyus').innerHTML = job.whyUs
      show(slot(article, 'whyus-wrap'))
    }

    addContact(article, job, t)

    buildUploads(root, article, job, t)
    buildQuestions(root, article, job, t)
    wireForm(root, article, job, t)

    addJsonLd(job)
    hide(target(root, 'loading'))
    show(article)
  }

  /** Ansprechpartner der Stelle. Ohne Adresse bleibt der Abschnitt weg —
   *  ältere Antworten der API kennen `contact` noch nicht. */
  function addContact(article, job, t) {
    var contact = job.contact || {}
    if (!contact.email) return

    var subject = (t.contact_subject || 'Bewerbung: {stelle}').replace('{stelle}', job.title)
    var mail = slot(article, 'contact-mail')
    mail.href = 'mailto:' + contact.email + '?subject=' + encodeURIComponent(subject)
    mail.textContent = contact.email

    var name = slot(article, 'contact-name')
    if (contact.name) name.textContent = contact.name
    else hide(name)

    show(slot(article, 'contact-wrap'))
  }

  /** Uploads: pro Pflichtdokument ein Feld. Hochgeladen wird sofort bei der
   *  Auswahl — beim Absenden gehen nur noch die Quittungen mit. */
  function buildUploads(root, article, job, t) {
    var wrap = slot(article, 'uploads')
    var tpl = root.querySelector('[data-template="upload"]')
    var state = (root._uploads = {})

    UPLOADS.forEach(function (spec) {
      if (!job[spec.flag]) return
      var node = tpl.content.cloneNode(true)
      var id = 'jf-' + spec.kind
      var label = slot(node, 'label')
      var input = slot(node, 'input')
      var hint = slot(node, 'hint')
      var status = slot(node, 'status')

      label.textContent = (t[spec.label] || spec.kind) + ' *'
      label.setAttribute('for', id)
      input.id = id
      input.required = true
      hint.textContent = t.upload_hint || ''

      input.addEventListener('change', async function () {
        var file = input.files && input.files[0]
        state[spec.kind] = null
        if (!file) return hide(status)

        status.textContent = t.upload_pending || '…'
        status.className = 'job-upload-status'
        show(status)

        try {
          var dataBase64 = await toBase64(file)
          var res = await postJSON(API + '/upload', {
            name: file.name,
            type: file.type,
            kind: spec.kind,
            dataBase64: dataBase64,
          })
          if (!res.ok || !res.body.ok) {
            status.textContent = res.body.message || t.error_text
            status.className = 'job-upload-status is-error'
            input.value = ''
            return
          }
          state[spec.kind] = res.body.file
          status.textContent = (t.upload_done || 'Hochgeladen') + ': ' + file.name
          status.className = 'job-upload-status is-ok'
        } catch (e) {
          status.textContent = t.error_text
          status.className = 'job-upload-status is-error'
          input.value = ''
        }
      })

      wrap.appendChild(node)
    })
  }

  function toBase64(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader()
      reader.onload = function () {
        // DataURL-Präfix abschneiden: "data:application/pdf;base64,XXXX"
        var s = String(reader.result)
        resolve(s.slice(s.indexOf(',') + 1))
      }
      reader.onerror = reject
      reader.readAsDataURL(file)
    })
  }

  function buildQuestions(root, article, job, t) {
    var wrap = slot(article, 'questions')
    var textTpl = root.querySelector('[data-template="question-text"]')
    var choiceTpl = root.querySelector('[data-template="question-choice"]')

    job.questions.forEach(function (q) {
      var label = q.text + (q.isRequired ? ' *' : '')

      if (q.type === 'SINGLE_CHOICE') {
        var node = choiceTpl.content.cloneNode(true)
        slot(node, 'label').textContent = label
        var options = slot(node, 'options')
        q.options.forEach(function (opt) {
          var wrapper = document.createElement('label')
          wrapper.className = 'job-option'
          var input = document.createElement('input')
          input.type = 'radio'
          input.name = 'question:' + q.id
          input.value = opt.id
          if (q.isRequired) input.required = true
          var span = document.createElement('span')
          span.textContent = opt.text
          wrapper.appendChild(input)
          wrapper.appendChild(span)
          options.appendChild(wrapper)
        })
        wrap.appendChild(node)
      } else {
        var textNode = textTpl.content.cloneNode(true)
        var id = 'jf-q-' + q.id
        var lbl = slot(textNode, 'label')
        var input2 = slot(textNode, 'input')
        lbl.textContent = label
        lbl.setAttribute('for', id)
        input2.id = id
        input2.name = 'question:' + q.id
        if (q.isRequired) input2.required = true
        wrap.appendChild(textNode)
      }
    })
  }

  function wireForm(root, article, job, t) {
    var form = target(root, 'form')
    var errorBox = target(root, 'form-error')
    var submit = target(root, 'submit')
    var openedAt = Date.now()

    form.addEventListener('submit', async function (event) {
      event.preventDefault()
      hide(errorBox)

      if (!form.reportValidity()) {
        errorBox.textContent = t.required_hint || ''
        show(errorBox)
        return
      }

      var files = []
      var missing = false
      UPLOADS.forEach(function (spec) {
        if (!job[spec.flag]) return
        var entry = root._uploads[spec.kind]
        if (!entry) missing = true
        else files.push(entry)
      })
      if (missing) {
        errorBox.textContent = t.required_hint || ''
        show(errorBox)
        return
      }

      var data = new FormData(form)
      var answers = {}
      job.questions.forEach(function (q) {
        var value = data.get('question:' + q.id)
        if (value) answers[q.id] = String(value)
      })

      submit.disabled = true
      var label = submit.textContent
      submit.textContent = t.submit_pending || '…'

      var res = await postJSON(API + '/apply', {
        slug: job.slug,
        firstName: data.get('firstName'),
        lastName: data.get('lastName'),
        email: data.get('email'),
        phone: data.get('phone') || undefined,
        answers: answers,
        files: files,
        consent: data.get('consent') === 'on',
        website: data.get('website') || '',
        elapsedMs: Date.now() - openedAt,
      }).catch(function () {
        return { ok: false, body: {} }
      })

      submit.disabled = false
      submit.textContent = label

      if (!res.ok || !res.body.ok) {
        errorBox.textContent = res.body.message || t.error_text
        show(errorBox)
        return
      }

      hide(form.parentElement)
      var result = target(root, 'result')
      show(result)
      result.scrollIntoView({ behavior: 'smooth', block: 'start' })
    })
  }

  /* ── Start ──────────────────────────────────────────────────────── */

  function boot() {
    var overview = document.querySelector('[data-jobs-overview]')
    if (overview) initOverview(overview)
    var detail = document.querySelector('[data-job-detail]')
    if (detail) initDetail(detail)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot)
  } else {
    boot()
  }
})()
